import type { LoadingSpinnerSize } from '@components/atoms';
import { LoadingSpinner, LoadingSpinnerColor } from '@components/atoms';
import { cn } from '@utils';
import { ButtonSpinnerColorMap } from '../button.type';

interface ButtonLoadingSpinnerProps {
	size: LoadingSpinnerSize;
	color?: LoadingSpinnerColor;
	className?: string;
}

export const ButtonLoadingSpinner: React.FC<ButtonLoadingSpinnerProps> = ({ size, color, className }) => {
	const finalColor = color ? ButtonSpinnerColorMap[color] : ButtonSpinnerColorMap[LoadingSpinnerColor.PRIMARY];

	return (
		<div className={cn(className)} data-aid="button-loading-spinner">
			<LoadingSpinner size={size} color={finalColor as unknown as LoadingSpinnerColor} />
		</div>
	);
};
